"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// 获取url参数
var searchParams = new URLSearchParams(location.search);
var SANDBOX = Boolean(searchParams.get('sandbox')) || /TestEnv\/1/.test(navigator.userAgent);
exports.default = SANDBOX;
